import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import LABELESPECIAL from '../../../business-const/Label/LabelEspecial'

import {
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
} from '../../../business-components/Formata/Formata'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    CardGridEstudoTabelaPadrao,
} from '../estudo-form/EstudoComp'



const SeguroVidaCotacaoFormTabelaEvolucaoValorResgate = ( { values, item } ) => {

    const report = false

    const TabelaEvolucaoValorResgate = () => {

        let headList = [
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosValor(LABELESPECIAL.ano, report),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idade, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorPremioAnualizadoAcumulado, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorResgate, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorSaldado, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.beneficioProlongado, report),
            },
        ]



        return (
            <TableExibeDados
                report={report}
                noMinW={true}
            >
                <TableHeadExibeDados
                    report={report}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {item.tabelaEvolucaoValorResgate?.map((item, ind) => {
                        return (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[0].colSpan}
                                    primeiraColuna={true}
                                >
                                    {formataTableCellBodyExibeDadosTexto(item.ano, report)}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[1].colSpan}
                                >
                                    {formataTableCellBodyExibeDadosTexto(item.idade, report)}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[2].colSpan}
                                >
                                    {formataTableCellBodyExibeDadosValor(item.valorPremioAnualizadoAcumulado, report)}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[3].colSpan}
                                >
                                    {formataTableCellBodyExibeDadosValor(item.valorResgate, report)}
                                </TableCellBodyExibeDados>

                                <TableCellBodyExibeDados
                                    colSpan={headList[4].colSpan}
                                >
                                    {formataTableCellBodyExibeDadosValor(item.valorSaldado, report)}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[5].colSpan}
                                >
                                    {formataTableCellBodyExibeDadosTexto(item.beneficioProlongado, report)}
                                </TableCellBodyExibeDados>
                             </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>  
        )
    }

    return (
        <DivFormEstudo>
            <CardGridEstudoTabelaPadrao
                values={values}
                SvgIcon={""}
                label={""}
                helpTextMorte={""}
                helpTextInvalidez={""}
                component={<TabelaEvolucaoValorResgate/>}
                popup={true}
            />
        </DivFormEstudo>
    )
}

export default SeguroVidaCotacaoFormTabelaEvolucaoValorResgate